<template>
  <div class="h-dialogContainer">
    <div class="row h-row-inputBox">
      <div class="col-sm-7 h-col-inputBox">
          <div class='h-inputLit'>
            <span>{{$t('Pui.pvi')}}</span>
          </div>
          <input class="e-input" :value='pvi' disabled="true"/>
      </div>
    </div>
    <br>
    <div class="h-borderBox">
      <div class="h-dialog-borderBox-topIcon">
        <div class="h-toolbarBg dialog-icon-style">
          <ejs-toolbar class="dialog-icon-style">
            <div class="dialog-icon-style" >
            </div>
          </ejs-toolbar>
        </div>
      </div>
      <div class="h-borderBox-content" style="overflow: hidden">
        <ejs-grid ref='grid' :dataSource="data" height='400px' :allowReordering='true' :allowResizing='true'>
          <e-columns>
            <e-column field='pui' clipMode='EllipsisWithTooltip' :headerText='$t("Pui.pui")' width='200' textAlign='Center'></e-column>
          </e-columns>
        </ejs-grid>
      </div>
    </div>
  </div>
</template>

<script>
import ajaxUrl from "../../../data/ajaxUrl";

export default {
  name: 'QryPuiDialog',
  components: {
  },
  data() {
    return {
      data: [],
      pvi: '',     
    };
  },
  methods: {
    getPuiListByPvi(record,neid) {
      const checkedRecord = {
        ...record[0],
      };
      console.log('checkedRecord',checkedRecord);
      this.pvi=checkedRecord.pvi;
      const params = {
        info: {
          neid: neid,
          msgid: "30490"
        },
        vo: {
            "pui":"",
            "pvi": checkedRecord.pvi,
        },
      };
      this.$axios.post(ajaxUrl.requestCommonD, params).then((response) => {
        const res = response.data;
        const dataSource = res.resultVal.puiList;
        const dataArray = [];
        for(let i=0;i<dataSource.length;i++){
          const param={pui:dataSource[i]};
          dataArray.push(param);
        }
        this.data= dataArray;

      });

    },
  },
};
</script>

<style scoped>

</style>
